import MConfig from "../Modules/MConfig";
import MRequest from "../Modules/MRequest";

export default class BProfileArticleReadStatusButtons
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-article-read-status-buttons__button`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		const selector = `${this.selector()}, ${this.selector()} *`;
		document.addEventListener("click", event => {
			if (event.target.matches(selector)) {
				const button = event.target.closest(`.profile-article-read-status-buttons__button`);
				const container = event.target.closest(`[data-article-id]`);

				const url = MConfig.getRoute("api.v2.articles.readStatus.create")
					.replace("{articleId}", container.dataset.articleId)
					;

				const data = {
					kind: "READ",
					setRead: parseInt(button.dataset.setRead) ? true : false,
				}

				MRequest.post(url, data).then(response => {
					container.dataset.isRead = response.data.timeRead ? 1 : 0;
				});
			}
		});
	}
}
